var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#D25E6A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11H31.5C32.6046 11 33.5 11.8954 33.5 13V27C33.5 28.1046 32.6046 29 31.5 29H16.5V11Z",
    fill: "white",
    fillOpacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8996 17.8313V18.9758H26.5913V17.8313H29.8996ZM27.3424 16.5151H28.866V21.6367C28.866 21.7774 28.8874 21.8871 28.9304 21.9657C28.9733 22.042 29.0329 22.0957 29.1092 22.1267C29.1879 22.1577 29.2785 22.1732 29.381 22.1732C29.4525 22.1732 29.5241 22.1672 29.5956 22.1553C29.6671 22.141 29.722 22.1303 29.7601 22.1231L29.9997 23.2569C29.9234 23.2807 29.8161 23.3081 29.6778 23.3391C29.5396 23.3725 29.3715 23.3928 29.1736 23.3999C28.8064 23.4142 28.4845 23.3654 28.2079 23.2533C27.9337 23.1412 27.7203 22.9672 27.5677 22.7311C27.4151 22.4951 27.34 22.197 27.3424 21.837V16.5151Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.2768V16H26.0157V17.2768H23.7732V23.3247H22.2425V17.2768H20Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C6.5 11.8954 7.39543 11 8.5 11H16.5V29H8.5C7.39543 29 6.5 28.1046 6.5 27V13Z",
    fill: "white",
    fillOpacity: 0.72
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.5L11.0286 21.0286C11.2889 21.2889 11.7111 21.2889 11.9714 21.0286L13.5 19.5",
    stroke: "#D25E6A",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionIcon);
export default __webpack_public_path__ + "static/media/accordion-icon.24dab864.svg";
export { ForwardRef as ReactComponent };